import React, { useState } from 'react';
import '../styles/Project.css';

import Project from './Project';

export default function ProjectList() {
  const [projects] = useState([
    {
      id: 1,
      title: 'YouTube Sync Player',
      overview:
        'A web application to synchronize youtube videos on different browsers using WebRTC. Also you can chat with your peers while watching the youtube video.',
      link: 'https://github.com/SrivatsanV/youtube-sync-player',
    },
    {
      id: 2,
      title: 'Canteen Management System',
      overview:
        'A Web application for handling concurrent order requests from customers to canteens/hotels. Dynamic addition of items by canteens to their menus and real time placement and receiving of orders is the main feature of this app.',
      link: 'https://github.com/SrivatsanV/Canteen-Management-System',
    },
    {
      id: 3,
      title: 'Flix Search',
      overview:
        'A responisive, UI centric web application built using ReactJS and the movieDb api',
      link: 'https://github.com/SrivatsanV/Flix--movies-app',
    },
    {
      id: 4,
      title: 'Bookmarker App',
      overview: 'A simple bookmarker app using html, css & javascript.',
      link: 'https://github.com/SrivatsanV/Bookmarker-app',
    },
    {
      id: 5,
      title: 'Todos App - React',
      overview: 'A todos app built using the MERN stack.',
      link: 'https://github.com/SrivatsanV',
    },
  ]);
  return (
    <div className="project-list">
      <div className="project-page-title">Projects</div>
      <div className="projects-page">
        {projects.map((p) => (
          <Project project={p} key={p.id} />
        ))}
      </div>
    </div>
  );
}
